module.exports = __webpack_public_path__ + "img/nodata.500ec262.png";